<template>
  <footer>
    <div class="f-t">
      <div class="navBox">
        <div class="link margin">
          <a href="/">首页</a>
          <img src="../../src/assets/img/xian.jpg" alt="" />
          <!-- <span>|</span> -->
          <a href="/#/aboutUs">关于我们</a>
          <img src="../../src/assets/img/xian.jpg" alt="" />
          <a href="/#/proDucts">产品&解决方案</a>
          <img src="../../src/assets/img/xian.jpg" alt="" />
          <a href="/#/serverCase">服务案例</a>
          <img src="../../src/assets/img/xian.jpg" alt="" />
          <a href="/#/news">新闻资讯</a>
          <img src="../../src/assets/img/xian.jpg" alt="" />
          <a href="/#/joinUs">加入连邦</a>
          <img src="../../src/assets/img/xian.jpg" alt="" />
          <a href="/#/connectUs">联系我们</a>
        </div>
      </div>
    </div>
    <div class="f-main margin">
      <el-row>
        <!-- <el-col :span="8" style="width: 375px">
          <div class="grid-content bg-purple tel">
            <p>服务热线</p>
            <img src="../assets/img/tel.png" alt />
             <p></p>
            <img src="" alt />
          </div>
        </el-col> -->
        <el-col :span="24" class="f-b-r">
          <div class="grid-content bg-purple-light">
            <el-col :span="8" class="col_width">
              <div class="grid-content bg-purple-light telbox e-col_first">
                <a>
                  <div class="icon" style="margin: 0 auto">
                    <img src="../assets/img/telicon.png" alt />
                  </div>
                  <span>13770322040</span>
                </a>
              </div>
            </el-col>
            <el-col :span="8" class="col_width">
              <div class="grid-content bg-purple-light telbox">
                <a>
                  <div class="icon" style="margin: 0 auto">
                    <img src="../assets/img/qq.png" alt />
                  </div>
                  <span>8088808556</span>
                </a>
              </div>
            </el-col>
            <el-col :span="8" class="col_width">
              <div class="grid-content bg-purple-light telbox">
                <div class="icon" style="margin: 0 auto">
                  <img src="../assets/img/msg.png" alt />
                </div>
                <span>casshern@fedtech.cc</span>
              </div>
            </el-col>
          </div>
        </el-col>
        <div class="erm">
          <div class="ermBox">
            <p>微信二维码</p>
            <div style="margin: 12px 0">
              <div class="parent">
                <ul class="oul">
                  <li>
                    <!-- <img src="../assets/img/erm.png" alt /> -->
                     <img  style="width:155px;height:153px" src="../assets/img/liantu.png" alt />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </el-row>
    </div>
    <div class="f-bottom">
      <div class="box">
        <div class="copy margin">
          <!-- <p>
            版权所有：江苏连邦信息技术有限公司 &nbsp;服务地址：
            南京市高新区丽景路2号软件园研发大厦B座十楼
          </p> -->
          <p>
            版权所有：江苏连邦信息技术有限公司 &nbsp;服务地址：
            南京市浦口区七瑶路7号11幢713室
          </p>
          <p>
            <img src="@/assets/img/00.png" alt="" style="float:left;margin: -3px 10px 0 0;">
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32011202000579"
              style="color: #fff;float:left;"
              >苏公网安备 32011202000579号 &nbsp;&nbsp;&nbsp;&nbsp;</a
            >
            <a
              href="https://beian.miit.gov.cn/"
              style="color: #fff;float:right;"
              > &nbsp;&nbsp;&nbsp;&nbsp;苏ICP备09047442号-11</a
            >
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "g-footer",
  data() {
    return {};
  },
};
</script>

<style lang="stylus" scoped>
footer {
  height: 370px;
  background: #f4f4f4;
  position: relative;

  .f-t {
    line-height: 92px;
    height: 92px;
    color: #cdcdcd;

    .navBox {
      border-bottom: 1px solid #e8e8e8;

      .link {
        a {
          color: #333333;
          cursor: pointer;
        }

        span {
          margin: 0 20px;
          color: #cdcdcd;
        }

        img {
          margin: 0 20px;
          color: #cdcdcd;
        }
      }
    }
  }

  .f-main {
    height: 228px;

    .tel {
      p {
        font-size: 12px;
        line-height: 46px;
        margin-top: 60px;
      }
    }

    .f-b-r {
      margin: 45px 0;

      .col_width{
        width: 290px;
      }

      .telbox {
        border-left: 1px solid #e8e8e8;
        text-align: center;
        padding-top: 10px;

        .icon {
          width: 62px;
          height: 62px;
          border-radius: 31px;
          background: #fff;
          padding: 16px 15px;
          margin: 0 98px;

          img {
            display: block;
            vertical-align: middle;
          }
        }
        div.telbox:not(.e-col_first){
          border: none;
        }

        span {
          display: block;
          font-size: 12px;
          padding: 30px 0;
          color: #808080;
        }
      }
    }
  }

  .f-bottom {
    .box {
      background: #c10000;
      color: #fff;
      height: 53px;

      .copy {
        width: 1200px;
        height: 46px;
        margin: 0 auto;

        p {
          color: #fff;
          font-size: 14px;
          display: inline-block;
          margin-top: 6px;

          &:fist-child {
            float: left;
          }

          &:last-child {
            float: right;
          }
        }
      }
    }

    /* .box {
      background: #c10000;
      color: #fff;
      padding:10px 0;
      .copy {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 46px;
        line-height:46px;
        p {
          color: #fff;
          position: relative; 设置子元素为相对定位，可让子元素不继承Alpha值
        }
      }
    } */
  }

  .erm {
    position: absolute;
    right: 0;
    top: -33px;

    .parent {
      width: 153px;
      overflow: hidden;

      ul {
        overflow: hidden;
        height: 153px;
        position: relative;
        width: 1000px;

        li {
          float: left;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .ermBox {
      background: #fff;
      padding: 30px 32px;

      p {
        font-size: 12px;
        line-height: 24px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/g_footer.vue